"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCoreMiddleware;

var _react = _interopRequireDefault(require("react"));

var _CarouselLayout = _interopRequireDefault(require("../../Activity/CarouselLayout"));

var _StackedLayout = _interopRequireDefault(require("../../Activity/StackedLayout"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RETURN_FALSE = function RETURN_FALSE() {
  return false;
};

function createCoreMiddleware() {
  return function () {
    return function (next) {
      return function (_ref) {
        var _ref$activity = _ref.activity,
            activity = _ref$activity === void 0 ? {} : _ref$activity,
            timestampClassName = _ref.timestampClassName; // TODO: [P4] Can we simplify these if-statement to something more readable?

        var type = activity.type; // Filter out activities that should not be visible

        if (type === 'conversationUpdate' || type === 'event') {
          return RETURN_FALSE;
        } else if (type === 'message') {
          var _activity$attachments = activity.attachments,
              attachments = _activity$attachments === void 0 ? [] : _activity$attachments,
              channelData = activity.channelData,
              text = activity.text;

          if ( // Do not show postback
          channelData && channelData.postBack || // Do not show messageBack if displayText is undefined
          channelData && channelData.messageBack && !channelData.messageBack.displayText || // Do not show empty bubbles (no text and attachments, and not "typing")
          !(text || attachments.length)) {
            return RETURN_FALSE;
          }
        } else if (type === 'typing' && activity.from.role === 'user') {
          // Do not show typing by oneself
          return RETURN_FALSE;
        }

        if (type === 'message' || type === 'typing') {
          if (type === 'message' && (activity.attachments || []).length > 1 && activity.attachmentLayout === 'carousel') {
            // The following line is not a React functional component, it's a middleware function.
            // Note that "children" is not a props, but first argument.
            var CarouselActivity = function CarouselActivity(children) {
              return _react.default.createElement(_CarouselLayout.default, {
                activity: activity,
                timestampClassName: timestampClassName
              }, children);
            };

            return CarouselActivity;
          } // The following line is not a React functional component, it's a middleware function.
          // Note that "children" is not a props, but first argument.


          var StackedActivity = function StackedActivity(children) {
            return _react.default.createElement(_StackedLayout.default, {
              activity: activity,
              timestampClassName: timestampClassName
            }, children);
          };

          return StackedActivity;
        }

        return next({
          activity: activity,
          timestampClassName: timestampClassName
        });
      };
    };
  };
}